import { axiosHttp } from "@/util/axios.js";

/**
 * 确认收货
 * @param { orderNo } data
 */
export function updateOrderStatus(data){
  return axiosHttp.$postAxios('/updateOrderStatus', data)
}

/**
 * 查询订单列表
 */
export function getMyOrderList(){
  return axiosHttp.$getAxios('/getMyOrderList')
}

/**
 * 取消订单
 * @param { orderNo } data
 */
export function cancelOrder(data){
  return axiosHttp.$postAxios('/cancelOrder', data)
}

/**
 * 查询订单详细信息
 * @param { orderNo } orderNo
 */
export function getOrderDetail(data){
  return axiosHttp.$getAxios('/getOrderDetailByOrderNo', data)
}

// 添加评论
export function addEvaluate(data){
  return axiosHttp.$postAxios('/access/addEvaluate', data)
}

/**
 *
 * @param { orderNo } data
 */
export function addOrders(data){
  return axiosHttp.$postAxios('/addOrder', data)
}

/**
 * 查询快递信息
 */
export function searchExpress(data) {
  return axiosHttp.$postAxios('/searchExpress', data)
}





// WEBPACK FOOTER //
// ./src/apis/orders/order.js